import { DocumentChunksResponse } from "../../types";
import { Learning } from "../types";

/**
 * Transforms API chunk data into Learning objects for the UI
 */
export function transformChunksToLearnings(chunksData?: DocumentChunksResponse): Learning[] {
  if (!chunksData) return [];

  return chunksData.chunks.map((chunk, index) => ({
    id: index + 1, // Use index as ID since chunk_id is a string
    name: chunk.title || `Chunk ${chunk.chunk_order_index + 1}`, // Use AI-generated title or fallback
    document_id: chunksData.document_id,
    document_name: chunksData.document_name,
    description:
      chunk.summary ||
      chunk.content.substring(0, 150) + (chunk.content.length > 150 ? "..." : ""), // Use AI summary or fallback to truncated content
    content: chunk.content,
    tags: chunk.tags && chunk.tags.length > 0 ? chunk.tags : [], // Use AI-generated tags
    retrievals: chunk.retrieval_count ?? 0, // Use actual retrieval count
    knowledge_type: chunk.knowledge_type, // Add knowledge type
    created_at: undefined,
    updated_at: undefined,
    user_id: undefined,
  }));
}
